<template>
  <div class="set-privilege--main flex flex-column">
    <div class="title" @mouseenter="sentLog(100115011)">
      设置免审核人员
      <el-tooltip effect="dark"  placement="right">
        <i class="r2-icon-action_help_outline"></i>
        <div slot="content">
          开启后，该员工共享到企业组价数据库的清单、定额、人材机、组价方案数据均自动通过审核，成为企业共享数据。
        </div>
      </el-tooltip>
    </div>
    <div class="main-content flex-1" id="table-box">
      <simple-table :height="tableHeight - (pagination.total > pagination.pageSize ? 108 : 68)" :fixedTable="true"
                    :showNoData="dataSource.length === 0"
                    no-data-text="暂无企业员工">
        <thead slot="header">
          <tr>
            <th v-for="(thItem, idx) in columns" :key="'th-' + idx" :width="thItem.width" class="font-left">
              {{thItem.title}}
            </th>
          </tr>
        </thead>
        <tbody slot="body">
          <tr v-for="(member, idx) in dataSource" :key="'member-' + idx">
            <td  v-for="(tdItem, index) in columns" :key="'td-' + index" :width="tdItem.width || 'auto'">
              <!-- 姓名 -->
              <span v-if="tdItem.key === 'userName'">{{member.userName}}</span>

              <!-- 账号 -->
              <template v-else-if="tdItem.key === 'account'">
                {{member.account}}
              </template>

              <!-- 角色 -->
              <template v-else-if="tdItem.key === 'role'">
                {{+member.role | formatFromList(roleList, 'value', 'name')}}
              </template>

              <!-- 操作 -->
              <template v-else>
                <div class="switch--wrapper">
                  <w-switch
                    v-model="member.verify"
                    active-color="#2079FA"
                    inactive-color="#ABAEB6"
                    inner-text
                    active-text="开"
                    inactive-text="关">
                  </w-switch>
                  <div class="mask" @click="switchHandle(member)"></div>
                </div>
              </template>

            </td>
          </tr>
        </tbody>
      </simple-table>
      <!-- 分页 -->
      <div class="page-box" style="margin-top: 10px;" v-if="pagination.total > pagination.pageSize">
        <w-pagination
          @current-change="handleCurrentChange"
          @size-change="handlePageSizeChange"
          :current-page.sync="pagination.current"
          background
          layout="total, prev, pager, next, jumper,sizes"
          :page-size="pagination.pageSize"
          :page-sizes="[50, 100]"
          :total="pagination.total">
        </w-pagination>
      </div>
    </div>
  </div>
</template>
<style lang="less" type="text/less">
  @import "index";
</style>
<script>
import databaseManageMixin from '@/assets/mixins/database-manage'
import DatabaseService from '@/assets/service/database'
// 表头数据
const columns = [
  {title: '姓名', key: 'userName', width: 15},
  {title: '账号', key: 'account', width: 15},
  {title: '账号角色', key: 'role', width: 10},
  {title: '免审核', key: 'verify', width: 10}
]
export default {
  name: 'ManageSetPrivilege',
  mixins: [databaseManageMixin],
  data () {
    return {
      columns,
      fetching: false
    }
  },
  methods: {
    // 1. 查询企业下员工列表
    getMembers () {
      this.loading = true
      const params = {
        pageNum: this.pagination.current || 1,
        pageSize: this.pagination.pageSize || 10
      }
      DatabaseService.getMembersSetPrivilege(params).then(res => {
        console.log(res)
        this.handleListData(res)
        // this.handleListData(require('@/assets/js/testData/configTask.json'))
        this.loading = false
      }).catch((e) => {
        console.log(e)
        this.loading = false
      })
    },
    // 1.1 处理返回的数据
    handleListData (res) {
      if (+res.code === 200 && res.data) {
        const list = res.data.list || []
        list.map((item) => {
          item.verify = +item.verify === 1
          item.portrait = 'https://account.glodon.com/avatar/show/' + item.gldUserId + '/32'
        })
        this.dataSource = list
        res.data.totalCount && (this.pagination.total = res.data.totalCount)
        res.data.pageNum && (this.pagination.current = res.data.pageNum)
        res.data.pageSize && (this.pagination.pageSize = res.data.pageSize)
      } else {
        this.$message.error(res.message)
      }
    },
    // 2. 开通/关闭 免审核权限
    switchHandle ({gldUserId, verify}) {
      if (!this.fetching) {
        this.fetching = true
        const params = {
          gldUserId,
          verify: verify ? 0 : 1
        }
        this.sentLog(100115012, {status: verify ? 2 : 1})
        DatabaseService.setPrivilege(params).then(res => {
          if (+res.code === 200) {
            this.$message.success('设置成功')
          } else {
            this.$message.warning(res.message)
          }
          this.getMembers()
          this.fetching = false
        }).catch((e) => {
          console.log(e)
          this.fetching = false
        })
      }
    }
  }
}
</script>
